import { Config } from '@/Config';

export function getCmsProductUrl(productId: string, productType?: string) {
  return `${Config.CMS_BASE_URL}/cms/EditProduct/${productType ?? 'AudioAlbum'}/${productId}`;
}
